<template>
  <div id="app">
    <Nav></Nav>
    <div class="toptit"></div>
    <div class="block">
      <h1>
        <span>业务</span>范围
      </h1>
    </div>
    <div class="business">
      <div class="business-first">
        <h1>
          <span style="font-family: Impact;">01</span>
        </h1>
        <h2>IP营销</h2>
        <h3>IP MARKETING</h3>
        <div class="details">
          <div>
            <img src="../assets/IPimg1.png" alt />
            <h1>
              <span>IP SOURCING</span>
            </h1>
            <p>基于推广及流量转化的需求,对行业市场趋势发展进行分析,定位IP资源、并精准匹配及深度及结合</p>
          </div>
          <div>
            <img src="../assets/IPimg2.png" alt />
            <h1>
              <span>资源整合</span>
            </h1>
            <p>借助各种传播工具及优质的资源，将品牌形象和产品信息传递给广大消费者，高效提升品牌产品的口碑及关注度</p>
          </div>
          <div>
            <img src="../assets/IPimg3.png" alt />
            <h1>
              <span>项目管理</span>
            </h1>
            <p>基于具体执行要求对项目进行管控，包括沟通、流程、推进、执行等管理工作</p>
          </div>
          <div>
            <img src="../assets/IPimg4.png" alt />
            <h1>
              <span>营销策划</span>
            </h1>
            <p>依据市场定位、目标受众分析，以新零售结合传统促销模式为目标进行品牌推广策略及主题活动的创意策划等</p>
          </div>
        </div>
      </div>
      <div class="business-second">
        <div class="business-second-tit">
          <h1>
            <span style="font-family:Impact;">02</span>
          </h1>
          <span>
            <p>产品定制</p>
            <p>TAILOR-MADE PRODUCTS</p>
          </span>
        </div>
        <div class="business-second-content">
          <div>
            <img src="../assets/IPimg5.png" alt />
          </div>
          <div class="titAndContent">
            <div>
              <h1>IP 订制</h1>
              <p>结合IP形象,内容,素材与合适的产品品类开发IP周边产品</p>
            </div>
            <div>
              <h1>品牌订制</h1>
              <p>根据需求开发品牌现有产品品类外的品类，并结合品牌核心价值作深度开发</p>
            </div>
            <div>
              <h1>创意开发</h1>
              <p>结合市场趋势自主创新研发，满足消费需求升级</p>
            </div>
          </div>
        </div>
      </div>
      <div class="business-third">
        <div class="business-third-tit">
          <h1>
            <span>03</span>
          </h1>
          <span>
            <p>跨界合作</p>
            <p>CROSS BRANDING</p>
          </span>
        </div>
        <div class="business-third-content">
          <div class="titAndContent">
            <div>
              <h1>创意开发</h1>
              <p>
                作为第三方助力合作伙伴促进多渠道合作，有效降低市场
                <br />营销成本，并提高效率，增强市场竞争力与商业伙伴及平台
                <br />合作，碰撞新业务模式并转化成商业价值
              </p>
            </div>
          </div>
          <div>
            <img src="../assets/IPimg6.png" alt />
          </div>
        </div>
      </div>
    </div>
    <BottomNav></BottomNav>
    <div class="num1">01</div>
    <div class="num2">02</div>
    <div class="num3">03</div>
    <dvi class="yewu-bg">
      <img src="../assets/yuwu-bg.png" alt />
    </dvi>
  </div>
</template>

<script>
import Nav from "../components/Nav";
import BottomNav from "../components/BottomNav";
import Vue from "vue";
export default {
  name: "Business",
  data() {
    return {};
  },
  methods: {},
  mounted() {
    window.onscroll = function() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      var topNav = document.getElementById("topNav");
      if (scrollTop > 0) {
        topNav.style.width = "100%";
        topNav.style.position = "fixed";
        topNav.style.top = "0";
        topNav.style.left = "0";
        topNav.style.paddingLeft = "33.5%";
        // topNav.style.zIndex = 11;
      } else {
        // topNav.style.paddingLeft = "0%";
        // topNav.style.width = "32.42%";
        // topNav.style.left = "33.5%";
        // topNav.style.zIndex = 9;
      }
      // if (scrollTop = 0) {
      //   topNav.style.width = "29.42%";
      // }
    };
  },
  components: { Nav, BottomNav }
};
</script>

<style lang="less" scoped>
#app {
  font-family: "微软雅黑";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
  @media screen and (min-width: 140px) {
    min-width: 1050px;
    margin: 0 auto;
  }
  @media screen and (min-width: 1920px) {
    min-width: 1240px;
    margin: 0 auto;
  }
}
.image {
  width: 100%;
}
.logoImg {
  width: 141px;
  height: 86px;
}
.tit {
  text-align: left;
  h1 {
    color: #fce04f;
    font-size: 61px;
    font-family: Impact;
    font-weight: 400;
    border-bottom: 2px solid #fce04f;
    width: 67px;
  }
  p {
    font-size: 20px;
  }
}
.block {
  background-color: #333333;
  height: 100px;
  display: flex;
  align-items: center;
  h1 {
    color: #ffffff;
    line-height: 110px;
    width: fit-content;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    margin: 0 0 0 35%;
    @media screen and (min-width: 140px) {
      font-size: 24px;
    }
    @media screen and (min-width: 1440px) {
      font-size: 24px;
    }
    @media screen and (min-width: 1920px) {
      font-size: 26px;
    }
    span {
      border-bottom: 4px solid #fce04f;
      padding-bottom: 5px;
    }
  }
}
.toptit {
  width: 100%;
  height: 56px;
}
.business {
  padding: 30px 0 100px 0;
  width: 60%;
  margin: 0 auto;
  position: relative;
  .business-first {
    margin: 0 auto;
    width: 100%;
    h1 {
      margin: 0;
      font-size: 60px;
      color: #fce04f;
      margin-bottom: 10px;
      // font-family: Impact;
      span {
        border-bottom: 4px solid #fce04f;
      }
    }
    h2 {
      margin: 0;
      padding-top: 10px;
      padding-bottom: 12px;
      font-weight: bold;
      @media screen and (min-width: 140px) {
        font-size: 18px;
      }
      @media screen and (min-width: 1920px) {
        font-size: 24px;
      }
    }
    h3 {
      margin: 0 0 50px 0;
      font-weight: bold;
      @media screen and (min-width: 140px) {
        font-size: 18px;
      }
      @media screen and (min-width: 1920px) {
        font-size: 24px;
      }
    }
    .details {
      display: flex;
      justify-content: space-between;
      & > div {
        width: 22.5%;
        img {
          width: 100%;
        }
        h1 {
          padding-bottom: 5px;
          width: fit-content;
          width: -webkit-fit-content;
          width: -moz-fit-content;
          color: #333;
          font-weight: bold;
          margin-top: 30px;
          margin-bottom: 20px;
          @media screen and (min-width: 140px) {
            font-size: 18px;
          }
          @media screen and (min-width: 1920px) {
            font-size: 24px;
          }
          span {
            padding-bottom: 5px;
          }
        }
        p {
          text-align: justify;
          color: #666;
          line-height: 20px;
          @media screen and (min-width: 140px) {
            font-size: 14px;
          }
          @media screen and (min-width: 1920px) {
            font-size: 16px;
          }
        }
      }
    }
  }
  .business-second {
    .business-second-tit {
      display: flex;
      justify-content: space-between;
      width: fit-content;
      width: -webkit-fit-content;
      width: -moz-fit-content;
      display: flex;
      align-items: center;
      p {
        text-align: left;
        margin: 0;
        color: #333;
      }
      h1 {
        font-size: 60px;
        color: #fce04f;
        span {
          border-bottom: 4px solid #fce04f;
        }
      }
      & > span {
        padding-left: 15px;
        line-height: 27px;
        padding-top: 40px;
        font-weight: bold;
        @media screen and (min-width: 140px) {
          font-size: 18px;
        }
        @media screen and (min-width: 1920px) {
          font-size: 24px;
        }
      }
    }
    .business-second-content {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      @media screen and (min-width: 140px) {
        width: 120%;
      }
      @media screen and (min-width: 1270px) {
        width: 100%;
      }
      div {
        width: 49%;
        img {
          width: 100%;
        }

        div {
          width: 100%;
          h1 {
            text-align: left;
            font-weight: bold;
            color: #333;
            @media screen and (min-width: 140px) {
              font-size: 18px;
            }
            @media screen and (min-width: 1920px) {
              font-size: 24px;
            }
          }
          p {
            text-align: left;
            color: #666;
            line-height: 20px;
            @media screen and (min-width: 140px) {
              font-size: 14px;
            }
            @media screen and (min-width: 1920px) {
              font-size: 16px;
            }
          }
        }
      }
      .titAndContent {
        padding-left: 50px;
        div {
          height: 30%;
        }
      }
    }
  }
  .business-third {
    padding-top: 10px;
    width: 100%;
    .business-third-tit {
      display: flex;
      justify-content: space-between;
      width: fit-content;
      width: -webkit-fit-content;
      width: -moz-fit-content;
      display: flex;
      align-items: center;
      p {
        text-align: left;
        margin: 0;
      }
      h1 {
        font-size: 60px;
        color: #fce04f;
        font-family: Impact;
        span {
          border-bottom: 4px solid #fce04f;
        }
      }
      & > span {
        padding-left: 15px;
        font-weight: bold;
        padding-top: 40px;
        @media screen and (min-width: 140px) {
          font-size: 18px;
        }
        @media screen and (min-width: 1920px) {
          font-size: 24px;
        }
      }
    }
    .business-third-content {
      // margin-top: 50px;
      display: flex;
      justify-content: space-between;
      
      div {
        width: 48%;
        img {
          width: 100%;
        }
        div {
          width: 100%;
          h1 {
            font-size: 24px;
            text-align: right;
            font-weight: bold;
            line-height: 50px;
            color: #333;
            @media screen and (min-width: 140px) {
              font-size: 18px;
            }
            @media screen and (min-width: 1920px) {
              font-size: 24px;
            }
          }
          p {
            text-align: right;
            color: #666;
            line-height: 20px;
            @media screen and (min-width: 140px) {
              font-size: 14px;
            }
            @media screen and (min-width: 1920px) {
              font-size: 16px;
            }
          }
        }
      }
      .titAndContent {
        padding-right: 50px;
        display: flex;
        align-items: center;
      }
    }
  }
}
.yewu-bg {
  position: absolute;
  bottom: 0px;
  z-index: -10;
  left: 10px;
  img {
    width: 100%;
  }
}
.num1 {
  position: absolute;
  font-size: 380px;
  font-family: Impact;
  line-height: 175px;
  top: 261px;
  left: 50px;
  color: #fce04f;
  opacity: 0.1;
}
.num2 {
  position: absolute;
  font-size: 380px;
  font-family: Impact;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 175px;
  opacity: 0.1;
  right: 0;
  top: 1075px;
}
.num3 {
  position: absolute;
  font-size: 380px;
  font-family: Impact;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 175px;
  opacity: 0.1;
  bottom: 500px;
  left: -50px;
}
</style>
<style lang="less">
// .el-carousel__container {
//   height: 500px;
// }
// .el-submenu__title:hover {
//   background-color: #fff !important;
// }
.el-submenu__title {
  color: #333 !important;
}
.el-submenu__title a {
  color: #333 !important;
}
</style>
